import React from "react"
import { Box, Container, Grid } from "@mui/material"
import { GetServerSideProps } from "next"
import { EntryFields, fetchContentfulRatgeberPages } from "utils/api/contentful"
import serializeJSON from "@secureo/common/utils/serializeJSON"
import Link from "components/i18n/Link"
import SEO from "components/SEO"
import BreadCrumbs from "components/BreadCrumbs"
import { SecureoBreadCrumb } from "@secureo/common/typings/Breadcrumb"

import { BiShareAlt } from "react-icons/bi"
import { CustomAppProps } from "../_app"

const asPath = "/beratungscenter/ratgeber"

const breadCrumbAncestors: SecureoBreadCrumb[] = [
	{
		href: "/beratungscenter",
		label: "Infocenter",
	},
]

const currentPath: SecureoBreadCrumb = {
	href: "/beratungscenter/ratgeber",
	label: "Ratgeber",
}

const RatgeberContentListPage = ({ posts, countryCode }: Props & CustomAppProps) => {
	const title = `Ratgeber // Tresoro.${countryCode.toLowerCase()}`
	const description = `Hier finden Sie alle unsere Ratgeber.`

	return (
		<>
			<SEO title={title} description={description} asPath={asPath} />
			<BreadCrumbs
				ancestors={breadCrumbAncestors}
				currentPath={currentPath}
				countryCode={countryCode}
			/>
			<Box my={5}>
				<Container>
					<h1>Alle Beiträge</h1>
					<Grid container spacing={3}>
						{posts.map((post) => {
							const { id, url, previewImageUrl, seoTitleTag, seoDescriptionTag } =
								post.fields
							return (
								<Grid item xs={12} sm={4} key={id}>
									<Link
										key={id}
										href={`/content/${url}`}
										style={{ color: "inherit" }}
									>
										{previewImageUrl && (
											<img
												src={previewImageUrl}
												alt={seoTitleTag}
												style={{
													height: 150,
													width: "100%",
													objectFit: "cover",
													borderRadius: 5,
												}}
											/>
										)}

										<div>
											<strong>{seoTitleTag}</strong>
										</div>
										<p>{seoDescriptionTag}</p>
										<div
											style={{
												display: "flex",
												alignItems: "center",
												justifyContent: "space-between",
											}}
										>
											<div>Lesen</div>
											<div>
												<BiShareAlt size="1.2rem " />
											</div>
										</div>
									</Link>
								</Grid>
							)
						})}
					</Grid>
				</Container>
			</Box>
		</>
	)
}

export const getServerSideProps: GetServerSideProps = async () => {
	const posts = await fetchContentfulRatgeberPages()

	const props: Props = {
		posts,
	}

	return {
		props: serializeJSON(props),
	}
}

interface Props {
	posts: { fields: EntryFields }[]
}

export default RatgeberContentListPage
